export const PROFILS: Record<string, number> = {
    VEND: 2,
    CDV: 3
}

export const PROFIL_KEYS = ['VEND', 'CDV'] as const

export type ProfilKey = typeof PROFIL_KEYS[number]

export const PROFIL_LABELS: Record<ProfilKey, string> = {
    VEND: 'Vendeurs',
    CDV: 'Chefs de ventes'
}
